import axios from "axios";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { SignUpVerification as View, toast } from "ui-components";

import { usePageLoaded } from "~auth/hooks/usePageLoaded";
import { useResendEmail } from "~auth/queries/useResendEmail";

export const SignUpVerification = () => {
	const isPageLoaded = usePageLoaded();
	const {
		_query: { email },
	} = useWebRouter();

	const resendEmail = useResendEmail();

	const onResendEmail = () => {
		toast.promise(resendEmail.mutateAsync({ email: email! }), {
			loading: "Sending email...",
			success: "Email sent!",
			error: (e) =>
				axios.isAxiosError(e) ? "Something went wrong!" : e.message,
		});
	};

	if (!isPageLoaded) return null;

	return (
		<View
			email={email!}
			onResendEmail={onResendEmail}
		/>
	);
};
